import Modal from 'components/Modal';
import { MODAL_BACKGROUND } from 'constants/common';
import pluralize from 'pluralize';
import React from 'react';

type ComponentProps = {
  resourceName: string;
  numberOfItems?: number;
  onDelete: () => void;
  onCancel: () => void;
  toggleShowModal: () => void;
};

const DeleteModal: React.FC<ComponentProps> = (props) => {
  const { resourceName, numberOfItems = 1, toggleShowModal, onCancel, onDelete } = props;

  const handleDelete = (): void => {
    onDelete();
  };

  const handleCancel = (): void => {
    onCancel();
  };

  const renderBody = (): JSX.Element => (
    <>
      <div className="absolute top-5 left-0 right-0 h-40 z-0">{MODAL_BACKGROUND}</div>

      <div className="flex flex-col mt-30 mb-8 gap-2">
        <h2 className="text-heading-1">{`Delete ${resourceName}?`}</h2>
        <p className="text-body">{`Are you sure you want to delete this ${
          numberOfItems > 1 ? pluralize(resourceName) : resourceName
        }?`}</p>
      </div>
    </>
  );

  return (
    <Modal
      title=" "
      body={renderBody()}
      okButton
      okButtonText="Yes, delete"
      okButtonOnClick={handleDelete}
      okButtonStyle="whitespace-no-wrap w-37"
      cancelButtonStyle="whitespace-no-wrap w-37"
      cancelButtonText="Nevermind"
      cancelButtonOnclick={handleCancel}
      toggleShowModal={toggleShowModal}
    />
  );
};

export default DeleteModal;
